import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: null,
  modulesAccess: []
};

const sectorWiseReducer = createReducer(initialState, {
  SECTOR_WISE_REQ: (state) => {
    state.loading = true;
    state.user = null;
    state.modulesAccess = [];
  },
  SECTOR_WISE_FETCH_SUC: (state, actions) => {
    const payload = actions.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = payload.data;
    state.modulesAccess = payload.modulesAccess;
  },
  SECTOR_WISE_ERROR: (state, actions) => {
    state.loading = false;
    state.status = null;
    state.message = null;
    state.data = null;
    state.modulesAccess = [];
  },
});

export default sectorWiseReducer;
